module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Beneath the Soil")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("Recent Titles by Fay Sampson from Severn House")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1-space-after"
  }, [_c('em', [_vm._v("The Suzie Fewings Genealogical Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("IN THE BLOOD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("A MALIGNANT HOUSE")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("THOSE IN PERIL")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("FATHER UNKNOWN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("THE OVERLOOKER")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-1"
  }, [_vm._v("BENEATH THE SOIL")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15742380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/alsoby.vue
// module id = 63
// module chunks = 0